module.exports = __webpack_public_path__ + "static/media/logo-white.044ace66.svg";